<template>
    <div class="hero half-height" :class="{'post-hero': isPost}">
        <div class="parallax-wrapper" data-parallax='{"y": 250, "smoothness": 10}'>
            <wp-image :image="backgroundImage"
                      :is-background="true"
                      size-sd="rectangle-sd"
                      :load-immediate="true"
                      class="hero-background">
                <div v-if="apply_background_overlay"
                     class="overlay"
                     :style="`background-color: ${background_overlay};`">
                </div>
            </wp-image>
        </div>
        <div class="hero-content" v-if="backgroundImage" >
            <div class="content-container" v-scroll-reveal="{ delay: 300 }">
                <h1 class="h2 white title">
                    {{ title }}
                </h1>
                <h3 v-if="!isPost" class="white description">
                    {{ description }}
                </h3>
                <p v-else class="white description">
                    {{ date }} {{ categories }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import {EventBus} from '../utils/EventBus'
    import Special from './components/Special'
    import ButtonLink from './components/ButtonLink'
    import {faChevronDown} from '@fortawesome/pro-regular-svg-icons/faChevronDown'

    export default {
        name: "HeroModule",
        components: {
            Special,
            ButtonLink
        },
        props: {
            background_image: [Boolean, Object],
            mobile_background_image: [Boolean, Object],
            apply_background_overlay: Boolean,
            background_overlay: String,
            title: String,
            description: String,
            isPost: {
                type: Boolean,
                default: false
            },
            categories: {
                type: Boolean | String,
                default: false
            },
            date: {
                type: Boolean | String,
                default: false
            },
        },
        computed: {
            downArrow() {
                return faChevronDown
            },
            isMobile() {
                return EventBus.isMobile
            },
            backgroundImage() {
                return this.isMobile && this.mobile_background_image ? this.mobile_background_image : this.background_image
            }
        }
    }
</script>

<style lang="scss" scoped>
    $leftMargin: 40px;

    .hero {
        position: relative;
        overflow: hidden;
        height: min-content;
        padding: 120px 0 60px;

        @media (max-width: $bp-mobile) {
            padding-bottom: 30px;
        }

        &.half-height {
            height: 50vh;
            min-height: 600px;

            @media (max-height: 500px) {
                min-height: 100vh;
            }
        }
    }

    .parallax-wrapper {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -22;
    }

    .hero-background {
        position: relative;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
    }

    .overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }

    .hero-content {
        position: relative;
        width: 100%;
        height: 100%;
        @include site-container;
    }

    .content-container {
        width: 100%;
        max-width: 600px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 0 0 0 40px;

        @media (max-width: $bp-mobile) {
            padding: 20px;
        }

        @media (min-width: $site-container-width) {
            padding: 0;
        }
    }

    .title {
        margin-bottom: 5px;
    }

    .description {
        margin: 0 0 40px;
        padding: 0;
        font-size: 20px;
        line-height: 26px;
        font-weight: 600;

        @media (max-width: $bp-mobile) {
            margin-bottom: 0;
        }
    }

    .post-hero {
        .content-container {
            max-width: 700px;
            justify-content: center;
        }

        .description {
            font-size: 18px;
            margin-bottom: 0;
        }
    }

</style>